import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/plus-circle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-017cb0d9")

_pushScopeId("data-v-017cb0d9")
const _hoisted_1 = { id: "section-upload-photo" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-sm font-normal text-red-lp-100 label-accordion flex flex-row pt-2" }, [
  /*#__PURE__*/_createTextVNode(" Wajib upload bukti foto jika perbedaan antara "),
  /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "  berat kargo dan berat timbang ulang mencapai 1 kg atau lebih ")
], -1)
const _hoisted_3 = { class: "bg-red-lp-50 p-4" }
const _hoisted_4 = { class: "flex flex-row mt-4 w-full gap-x-2" }
const _hoisted_5 = {
  class: "flex flex-row gap-x-4",
  style: {"width":"380px"}
}
const _hoisted_6 = {
  class: "relative flex flex-col my-2 items-center justify-center",
  style: {"width":"120px"}
}
const _hoisted_7 = { class: "text-10px xxl:text-11px font-montserrat font-normal text-center my-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "text-12px border-r pr-4",
  style: {"border-color":"#eabcbe"}
}, [
  /*#__PURE__*/_createVNode("p", { class: "font-semibold font-montserrat text-gray-lp-300" }, " Panduan foto : "),
  /*#__PURE__*/_createVNode("ul", { class: "list-disc pl-5" }, [
    /*#__PURE__*/_createVNode("li", { class: "font-normal xxl:text-13px mt-2" }, " Foto memiliki resolusi bagus. "),
    /*#__PURE__*/_createVNode("li", { class: "font-normal xxl:text-13px w-" }, " Berat aktual pada timbangan harus terbaca jelas. "),
    /*#__PURE__*/_createVNode("li", { class: "font-normal xxl:text-13px" }, " Semua paket yang ditimbang harus terlihat jelas. "),
    /*#__PURE__*/_createVNode("li", { class: "font-normal xxl:text-13px" }, " Minimal 1 foto ")
  ])
], -1)
const _hoisted_9 = { class: "pl-4 flex flex-row items-center overflow-y-auto" }
const _hoisted_10 = { class: "flex flex-row gap-4 mb-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_card = _resolveComponent("card")!
  const _component_UploadImageTiny = _resolveComponent("UploadImageTiny")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Accordion, {
      onUpdate: _ctx.onClick,
      ref: "accordion-adjustment",
      modelValue: _ctx.showViewAdjustment,
      bgColor: "bg-red-lp-50",
      borderHeader: "border-b",
      mainBorderEdge: "",
      borderBody: "border-none",
      defaultOpened: _ctx.defaultOpened,
      label: _ctx.title,
      chevrons: ['chevron-up-red', 'chevron-down-red'],
      class: 
        `text-12px xxl:text-14px ${_ctx.marginBottom ? 'mb-5' : ''} ${
          _ctx.isShaking ? 'animate-shaking alerts-border' : 'border-none'
        } rounded-md`
      ,
      customLabel: "",
      customWidthHeader: "w-19/20"
    }, {
      "custom-label": _withId(() => [
        _hoisted_2
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.photoGuides, (key) => {
                return (_openBlock(), _createBlock(_component_card, {
                  class: "px-2",
                  key: key
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("img", {
                        src: require(`@/app/ui/assets/svg/${key.source}.svg`),
                        class: "h-28 w-28 object-cover rounded",
                        alt: "result-image"
                      }, null, 8, ["src"])
                    ]),
                    _withDirectives(_createVNode("p", _hoisted_7, null, 512), [
                      [_directive_sanitize_html, key.desc]
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _hoisted_8
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.proofPhotos, (photo, index) => {
                  return (_openBlock(), _createBlock("div", { key: index }, [
                    _createVNode(_component_UploadImageTiny, {
                      accept: "image/png, image/jpg, image/jpeg",
                      widthContentCard: _ctx.proofPhotos.length > 2 ? 'w-24' : '',
                      titleSize: "10",
                      onUpload: _ctx.onUpload,
                      onRemove: _ctx.onRemove,
                      title: photo?.desc,
                      modelValue: _ctx.attachmentImage[index],
                      "onUpdate:modelValue": ($event: any) => (_ctx.attachmentImage[index] = $event),
                      defaultImage: _ctx.generateDefaultImage(index),
                      maxSize: 5,
                      watermark: _ctx.watermark,
                      multipleIndex: index,
                      disabled: _ctx.getRulePieceDisabled,
                      customWatermark: _ctx.customWatermark
                    }, null, 8, ["widthContentCard", "onUpload", "onRemove", "title", "modelValue", "onUpdate:modelValue", "defaultImage", "watermark", "multipleIndex", "disabled", "customWatermark"])
                  ]))
                }), 128))
              ]),
              (_ctx.proofPhotos.length < _ctx.maxPhoto)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAddImage && _ctx.onAddImage(...args))),
                    src: _imports_0,
                    alt: "plus-circle-red",
                    class: "w-5 h-5 ml-4 cursor-pointer"
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onUpdate", "modelValue", "defaultOpened", "label", "class"])
  ]))
})